var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addressText"},[_c('span',[_vm._v(_vm._s(_vm.modelRow.oesDisplayValue))]),(_vm.validationFlag && _vm.address.countryCode === 'AUS')?_c('font-awesome-icon',{class:_vm.getClass,attrs:{"title":_vm.getTooltip,"icon":_vm.getIcon,"focusable":"false"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }